export const RU_LETTERS = [
  [
    {
      name: 'Ё',
    },
    {
      name: 'Й',
    },
    {
      name: 'Ц',
    },
    {
      name: 'У',
    },
    {
      name: 'К',
    },
    {
      name: 'Е',
    },
    {
      name: 'Н',
    },
    {
      name: 'Г',
    },
    {
      name: 'Ш',
    },
    {
      name: 'Щ',
    },
    {
      name: 'З',
    },
    {
      name: 'Х',
    },
    {
      name: 'Ъ',
    },
  ],
  [
    {
      name: 'Ф',
    },
    {
      name: 'Ы',
    },
    {
      name: 'В',
    },
    {
      name: 'А',
    },
    {
      name: 'П',
    },
    {
      name: 'Р',
    },
    {
      name: 'О',
    },
    {
      name: 'Л',
    },
    {
      name: 'Д',
    },
    {
      name: 'Ж',
    },
    {
      name: 'Э',
    },
  ],
  [
    {
      name: 'Я',
    },
    {
      name: 'Ч',
    },
    {
      name: 'С',
    },
    {
      name: 'М',
    },
    {
      name: 'И',
    },
    {
      name: 'Т',
    },
    {
      name: 'Ь',
    },
    {
      name: 'Б',
    },
    {
      name: 'Ю',
    },
  ],
];
